import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { TextButton } from '@/components/button'
import { colors, fontWeights } from '@/styles'
import Summary from './summary'
import { show as showMobileView } from './modal'

const Wrapper = styled.div`
  > :not(:last-child) {
    margin-bottom: 16px;
  }
`
const ViewDetailsButton = styled(TextButton)`
  font-weight: ${fontWeights.bold};
  font-size: 14px;
  line-height: 20px;
  color: ${colors.blue32};
  text-decoration-line: underline;
  padding: 0;
  margin: 0 0 0 12px;
`

const MobileView = ({ data, application, isLocked, isLoading, standalone }) => {
  const { t } = useTranslation()
  const handleClick = () => {
    showMobileView({ data, application, isLocked, isLoading, standalone })
  }

  return (
    <Wrapper>
      <Summary data={data} isLocked={isLocked} isLoading={isLoading} />
      <ViewDetailsButton onClick={handleClick}>
        {t('l.application.view.view_details.label', 'View details')}
      </ViewDetailsButton>
    </Wrapper>
  )
}

export default MobileView
